import * as React from 'react';

// REDUX
import { useAppSelector } from '../../../store';

// COMPONENTS
import Button from '../../../components/Button';
import SafeHtml from '../../../components/SafeHtml';
import DownloadLink from '../../../components/DownloadLink';
import DisplayDateTime from '../../../components/DisplayDateTime';

// TYPES
import { ComplaintsProgressViewTypes, ViewTypes } from './ComplaintsProgressModal';

const ReadActivity: React.FC<ComplaintsProgressViewTypes> = ({ complaintId, activity = {}, showView, closeModal }) => {
	// Check if Organisation is active
	const isOrganisationActive = useAppSelector((state) => state.user.isOrganisationActive);

	const { canUpdate, id, title, occurrence, creator, description, attachments } = activity;

	return (
		<article className="feed-article">
			<header>
				<h2 className="heading h4">{title}</h2>

				<time>
					<DisplayDateTime>{occurrence}</DisplayDateTime>
				</time>
			</header>

			<section>
				<h3 className="subheading">Logged By</h3>

				<p>{creator}</p>
			</section>

			<section>
				<h3 className="subheading">Description of action taken</h3>

				{description ? <SafeHtml>{description}</SafeHtml> : <p>None</p>}
			</section>

			<section>
				<h3 className="subheading">Attachments</h3>

				{attachments && attachments.length > 0 ? (
					<ul>
						{attachments.map((attachment, index) => (
							<li key={index}>
								<DownloadLink url={attachment.attachmentUrl} name={attachment.displayFileName} />
							</li>
						))}
					</ul>
				) : (
					<p>None</p>
				)}
			</section>

			{isOrganisationActive && canUpdate && (
				<section className="mtop-40">
					{canUpdate && (
						<Button className="btn-secondary w-100" onClick={() => showView(ViewTypes.Update)}>
							Edit
						</Button>
					)}
				</section>
			)}

			<section className="actions">
				<Button className="btn-primary full-width" onClick={closeModal}>
					Close
				</Button>
			</section>

			{isOrganisationActive && canUpdate && (
				<section className="top-40">
					<Button className="btn-text w-100" onClick={() => showView(ViewTypes.Delete)}>
						Delete activity
					</Button>
				</section>
			)}
		</article>
	);
};

export default ReadActivity;
